import React from "react";
import {
  DollarSign,
  Target,
  Shield,
  Hash,
  Building,
  Calendar,
  Clock,
  User,
  Percent,
  Activity,
  Bell,
  TrendingUp
} from "lucide-react";

const NA = (v) => (v ? v : "N/A");

const AllocationCard = ({ item }) => {
  return (
    <div className="customer-port-folio-portfolioAllocation-card">

      {/* STOCK NAME */}
      <div className="customer-port-folio-portfolioAllocation-stockname">
        {NA(item.stockName)}
      </div>

      {/* TOP HIGHLIGHTED ROW */}
      <div className="customer-port-folio-portfolioAllocation-toprow">
        <div><Building size={18}/> Sector: {NA(item.sector)}</div>
        <div><Hash size={18}/> Quantity: {NA(item.qty)}</div>
        <div><DollarSign size={18}/> Amount: ₹{NA(item.amount)}</div>
        <div><Activity size={18}/> ISIN: {NA(item.isin)}</div>
        <div><Percent size={18}/> Profit %: {NA(item.percentProfit)}</div>
       
        
      </div>

      {/* BOTTOM GRID */}
      <div className="customer-port-folio-portfolioAllocation-grid">
         <div><Target size={18}/> Target: {NA(item.target)}</div>
        <div><Shield size={18}/> Stoploss: {NA(item.stoploss)}</div>
        <div><TrendingUp size={16}/> Trailing Target: {NA(item.trailingTarget)}</div>
        <div><Shield size={16}/> Trailing SL: {NA(item.trailingSL)}</div>
        <div><User size={16}/> Placed By: {NA(item.placedBy)}</div>
        <div><DollarSign size={16}/> Bought At: {NA(item.boughtAt)}</div>
        <div><Calendar size={16}/> Buying Date: {NA(item.buyingDate)}</div>
        <div><Clock size={16}/> Buying Time: {NA(item.buyingTime)}</div>
        <div><User size={16}/> Client Code: {NA(item.clientCode)}</div>
        <div><Activity size={16}/> Result: {NA(item.result)}</div>
        <div><Bell size={16}/> SL Alert: {NA(item.triggerSLNotification)}</div>
        <div><Bell size={16}/> Target Alert: {NA(item.triggerTargetNotification)}</div>

      </div>

    </div>
  );
};

export default AllocationCard;